// slices/vehicleQuestionSlice.ts
import { FleetDTO, VehicleQuestion } from "@/interfaces/Company";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  questions: [] as VehicleQuestion[],
  fleetData: [] as FleetDTO[],
  // fleetData: [] as FleetDTOV2[],
  totalOwned: 0,
  totalContractors: 0,
  totalLeasing: 0,
  totalRenting: 0,
  totalWorkers: 0,
  totalQuantity: 0,
};

const vehicleQuestionSlice = createSlice({
  name: "vehicleQuestions",
  initialState,
  reducers: {
    setVehicleQuestions: (state, action: PayloadAction<VehicleQuestion[]>) => {
      state.questions = action.payload;
    },
    clearVehicleQuestions: (state) => {
      state.questions = [];
    },
    setFleetData: (state, action: PayloadAction<FleetDTO[]>) => {
      state.fleetData = action.payload;
      calculateTotals(state);
    },
    updateFleetData: (state, action: PayloadAction<FleetDTO>) => {
      const updatedData = action.payload;
      const index = state.fleetData.findIndex(
        (data) => data.vehicle_question === updatedData.vehicle_question
      );
      if (index !== -1) {
        state.fleetData[index] = updatedData;
      } else {
        state.fleetData.push(updatedData);
      }
      calculateTotals(state);
    },
    clearFleetData: (state) => {
      state.fleetData = [];
    },
  },
});

const calculateTotals = (state: typeof initialState) => {
  state.totalOwned = state.fleetData.reduce(
    (total, item) => total + item.quantity_owned,
    0
  );
  state.totalContractors = state.fleetData.reduce(
    (total, item) => total + item.quantity_contractors,
    0
  );
  state.totalLeasing = state.fleetData.reduce(
    (total, item) => total + item.quantity_leasing,
    0
  );
  state.totalRenting = state.fleetData.reduce(
    (total, item) => total + item.quantity_renting,
    0
  );
  state.totalWorkers = state.fleetData.reduce(
    (total, item) => total + item.quantity_workers,
    0
  );
  state.totalQuantity = state.fleetData.reduce(
    (total, item) =>
      total +
      item.quantity_owned +
      item.quantity_contractors +
      item.quantity_leasing +
      item.quantity_renting +
      item.quantity_workers,
    0
  );
};

export const {
  setVehicleQuestions,
  clearVehicleQuestions,
  setFleetData,
  updateFleetData,
  clearFleetData,
} = vehicleQuestionSlice.actions;

export default vehicleQuestionSlice.reducer;
